import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex h-[calc(100vh-52px)]" }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col h-full items-center justify-center w-full"
}
const _hoisted_3 = {
  key: 0,
  class: "flex w-full h-full"
}
const _hoisted_4 = {
  key: 1,
  class: "flex w-full h-full"
}
const _hoisted_5 = {
  key: 2,
  class: "flex w-full h-full"
}

import MainLayout from "@/layouts/MainLayout.vue";
import client from "@/utils/axios";
import { computed, onUnmounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import AbnahmeView from "./AbnahmeView.vue";
import QcView from "./QcView.vue";
import RegularView from "./RegularView.vue";
import { createClient } from "@supabase/supabase-js";
import { ImageBatch } from "@/types";
import SecondaryPageHeader from "@/components/PageHeader/SecondaryPageHeader.vue";
import PhaseSidemenu from "@/components/Sidebar/Redesign/PhaseSidemenu.vue";
import { useUserStore } from "@/stores/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'PhasePage',
  setup(__props) {

const route = useRoute();
const userStore = useUserStore();

const phaseData = ref();
const phaseStatusId = ref(null);
const isLoading = ref(false);
const isAddImageModalOpen = ref(false);
const isBaumappeOpen = ref(false);

const selectedPhase = ref();
let currentLanguage = computed(() => userStore.language);
let lastDatabaseTranslationUpdateTimestamp = computed(
  () => userStore.translationsUpdateTimestamp
);

let supabase = createClient(
  process.env.VUE_APP_SUPABASE_URL || "",
  process.env.VUE_APP_SUPABASE_API_KEY || ""
);

let batches = ref<Array<ImageBatch>>([]);

const toggleIsAddImageModalOpen = (isOpen: boolean) => {
  isAddImageModalOpen.value = isOpen;
};

const toggleBaumappe = (isOpen: boolean) => {
  isBaumappeOpen.value = isOpen;
};

// Fetch data
const getPhaseDetails = async () => {
  const projectId = route.params.id;
  const phaseId = route.params.phaseId;
  isLoading.value = true;

  try {
    const response = await client.get(
      `/projects/${projectId}/phase/${phaseId}?locale=${currentLanguage.value}`
    );
    phaseData.value = response.data;
    batches.value = response.data.batches;
    let tempPhase = response.data.phases.find(
      (item: any) => Number(item.phaseId) === Number(phaseId)
    );

    phaseStatusId.value = tempPhase?.phaseStatus?.id;
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const handleImagesChanges = (payload: any) => {
  let newBatchImage = payload.new;
  if (payload.eventType === "INSERT") {
    let tempBatch: any = batches.value.find(
      (item: any) => item.id === newBatchImage.images_batch
    );
    if (tempBatch) {
      tempBatch.images.push(newBatchImage);
    }
  }
  if (payload.eventType === "UPDATE") {
    let tempBatch: any = batches.value.find(
      (item: any) => item.id === newBatchImage.images_batch
    );
    if (tempBatch) {
      let tempImage = tempBatch.images.find(
        (image: any) => image.id === newBatchImage.id
      );
      if (tempImage) {
        tempImage.status = newBatchImage.status;
        tempImage.internet_speed = newBatchImage.internet_speed;
      }
    }
  }
};

const salesforceLink = computed(() => {
  if (phaseData.value) {
    let phase = phaseData.value?.phases.find(
      (phase: any) => phase.phaseId === route.params.phaseId
    );
    if (phase) {
      return `https://smalt.lightning.force.com/lightning/r/Phase__c/${phase.salesforceId}/view`;
    }
    return null;
  }
  return null;
});

const handleImagesBatchChanges = (payload: any) => {
  if (payload.eventType === "INSERT") {
    let newBatch = payload.new;
    newBatch.images = [];
    batches.value.push(newBatch);
  }
};

watch(
  () => route.params.phaseId, // Watch for the 'id' param change in the route
  async (newId, oldId) => {
    if (newId !== oldId) {
      await getPhaseDetails();

      let currentPhaseProgress = phaseData.value.phases.find(
        (item: any) => item.phaseId === Number(newId)
      );

      if (currentPhaseProgress) {
        supabase
          .channel("images_batch")
          .on(
            "postgres_changes",
            {
              event: "*",
              schema: "public",
              table: "installation_images_batch",
              filter: `phase_progress_id=eq.${currentPhaseProgress?.phaseProgressId}`,
            },
            handleImagesBatchChanges
          )
          .subscribe();
        supabase
          .channel("images")
          .on(
            "postgres_changes",
            {
              event: "*",
              schema: "public",
              table: "installation_images",
              filter: `phase_progress_id=eq.${currentPhaseProgress?.phaseProgressId}`,
            },
            handleImagesChanges
          )
          .subscribe();
      } else {
        console.error("Cannot find phase progress id.");
      }
      selectedPhase.value = newId; // Trigger the API call when the route param changes
    }
  },
  { immediate: true } // Immediately run on component mount
);

onUnmounted(() => {
  supabase.removeAllChannels();
});

watch(
  currentLanguage,
  async (newLang: any, oldLang: any) => {
    if (newLang && oldLang && newLang !== oldLang) {
      await getPhaseDetails();
    }
  },
  { immediate: true }
);

watch(
  lastDatabaseTranslationUpdateTimestamp,
  async (newTimestamp: any, oldTimestamp: any) => {
    if (newTimestamp && oldTimestamp && newTimestamp !== oldTimestamp) {
      await getPhaseDetails();
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(SecondaryPageHeader, {
        "phase-details": phaseData.value,
        "salesforce-link": salesforceLink.value,
        "is-baumappe-open": isBaumappeOpen.value,
        "has-baumappe": phaseData.value?.project?.baummape !== null,
        onToggleBaumappe: toggleBaumappe,
        onToggleIsAddImageModalOpen: toggleIsAddImageModalOpen
      }, null, 8, ["phase-details", "salesforce-link", "is-baumappe-open", "has-baumappe"]),
      _createElementVNode("div", _hoisted_1, [
        (phaseData.value)
          ? (_openBlock(), _createBlock(PhaseSidemenu, {
              key: 0,
              "phase-page": phaseData.value,
              "is-loading": isLoading.value
            }, null, 8, ["phase-page", "is-loading"]))
          : _createCommentVNode("", true),
        (phaseData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (phaseStatusId.value === 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (phaseData.value)
                      ? (_openBlock(), _createBlock(AbnahmeView, {
                          key: 0,
                          batches: _unref(batches),
                          "phase-id": Number(_unref(route).params.phaseId),
                          "project-id": _unref(route).params.id + '',
                          "phase-details": phaseData.value,
                          "is-add-image-modal-open": isAddImageModalOpen.value,
                          "is-baumappe-open": isBaumappeOpen.value,
                          "has-baumappe": phaseData.value?.project?.baummape !== null,
                          onToggleBaumappe: toggleBaumappe,
                          onToggleIsAddImageModalOpen: toggleIsAddImageModalOpen,
                          onRefresh: getPhaseDetails
                        }, null, 8, ["batches", "phase-id", "project-id", "phase-details", "is-add-image-modal-open", "is-baumappe-open", "has-baumappe"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (phaseStatusId.value === 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (phaseData.value)
                      ? (_openBlock(), _createBlock(QcView, {
                          key: 0,
                          batches: _unref(batches),
                          "phase-id": Number(_unref(route).params.phaseId),
                          "project-id": _unref(route).params.id + '',
                          "phase-details": phaseData.value,
                          "is-add-image-modal-open": isAddImageModalOpen.value,
                          "is-baumappe-open": isBaumappeOpen.value,
                          "has-baumappe": phaseData.value?.project?.baummape !== null,
                          onToggleBaumappe: toggleBaumappe,
                          onToggleIsAddImageModalOpen: toggleIsAddImageModalOpen,
                          onRefresh: getPhaseDetails
                        }, null, 8, ["batches", "phase-id", "project-id", "phase-details", "is-add-image-modal-open", "is-baumappe-open", "has-baumappe"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (phaseStatusId.value !== 4 && phaseStatusId.value !== 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (phaseData.value)
                      ? (_openBlock(), _createBlock(RegularView, {
                          key: 0,
                          batches: _unref(batches),
                          "phase-id": Number(_unref(route).params.phaseId),
                          "phase-details": phaseData.value,
                          "is-add-image-modal-open": isAddImageModalOpen.value,
                          "is-baumappe-open": isBaumappeOpen.value,
                          "has-baumappe": phaseData.value?.project?.baummape !== null,
                          onToggleBaumappe: toggleBaumappe,
                          onToggleIsAddImageModalOpen: toggleIsAddImageModalOpen,
                          onRefresh: getPhaseDetails
                        }, null, 8, ["batches", "phase-id", "phase-details", "is-add-image-modal-open", "is-baumappe-open", "has-baumappe"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})